export var EPurOrderStatus;
(function (EPurOrderStatus) {
    EPurOrderStatus["Bconfirm"] = "1";
    EPurOrderStatus["Bship"] = "2";
    EPurOrderStatus["Shipped"] = "3";
    EPurOrderStatus["Complete"] = "4";
    EPurOrderStatus["Invalid"] = "5";
    EPurOrderStatus["SumAndSplit"] = "2";
    EPurOrderStatus["ToAudit"] = "6";
})(EPurOrderStatus || (EPurOrderStatus = {}));
export var EPurInStatus;
(function (EPurInStatus) {
    EPurInStatus["Bconfirm"] = "1";
    EPurInStatus["Confirmed"] = "2";
    EPurInStatus["Invalid"] = "3";
})(EPurInStatus || (EPurInStatus = {}));
export var EShipStatus;
(function (EShipStatus) {
    EShipStatus["NoShip"] = "0";
    EShipStatus["PartShip"] = "1";
})(EShipStatus || (EShipStatus = {}));
export var EPurSortingStatus;
(function (EPurSortingStatus) {
    EPurSortingStatus["Bsubmit"] = "0";
    EPurSortingStatus["Sorting"] = "1";
    EPurSortingStatus["Submited"] = "2";
    EPurSortingStatus["Invalid"] = "6";
})(EPurSortingStatus || (EPurSortingStatus = {}));
export var EServiceStatus;
(function (EServiceStatus) {
    EServiceStatus["NoOpen"] = "0";
    EServiceStatus["Opened"] = "1";
    EServiceStatus["Using"] = "2";
    EServiceStatus["Overdue"] = "3";
})(EServiceStatus || (EServiceStatus = {}));
export var EServiceStatusConfig = {
    'basic': 'S00001',
    'erp': 'S00002',
    'sorting': 'S00003',
    'senior': 'S00004',
    'market': 'S00005',
    'xdfw': 'S00007',
    'zzsy': 'S00008',
    'multOrg': 'S00009',
    'interMall': 'S00006',
    'applicationOrder': 'S00011',
    'balance': 'S00012',
    'reports': 'S00013',
    'thirdSystem': 'S00014'
};
export var EPlanOrderForUpperSupStatus;
(function (EPlanOrderForUpperSupStatus) {
    EPlanOrderForUpperSupStatus[EPlanOrderForUpperSupStatus["ToAudit"] = 1] = "ToAudit";
    EPlanOrderForUpperSupStatus[EPlanOrderForUpperSupStatus["Audited"] = 2] = "Audited";
    EPlanOrderForUpperSupStatus[EPlanOrderForUpperSupStatus["Invalid"] = 5] = "Invalid";
    EPlanOrderForUpperSupStatus[EPlanOrderForUpperSupStatus["Complete"] = 3] = "Complete";
})(EPlanOrderForUpperSupStatus || (EPlanOrderForUpperSupStatus = {}));
export var EPurchaseOrderForUpperSupStatus;
(function (EPurchaseOrderForUpperSupStatus) {
    EPurchaseOrderForUpperSupStatus[EPurchaseOrderForUpperSupStatus["ToAudit"] = 1] = "ToAudit";
    EPurchaseOrderForUpperSupStatus[EPurchaseOrderForUpperSupStatus["Audited"] = 2] = "Audited";
    EPurchaseOrderForUpperSupStatus[EPurchaseOrderForUpperSupStatus["Invalid"] = 4] = "Invalid";
    EPurchaseOrderForUpperSupStatus[EPurchaseOrderForUpperSupStatus["Complete"] = 3] = "Complete";
})(EPurchaseOrderForUpperSupStatus || (EPurchaseOrderForUpperSupStatus = {}));
export var EPurchaseRefundForUpperSupStatus;
(function (EPurchaseRefundForUpperSupStatus) {
    EPurchaseRefundForUpperSupStatus[EPurchaseRefundForUpperSupStatus["ToAudit"] = 1] = "ToAudit";
    EPurchaseRefundForUpperSupStatus[EPurchaseRefundForUpperSupStatus["Audited"] = 2] = "Audited";
    EPurchaseRefundForUpperSupStatus[EPurchaseRefundForUpperSupStatus["Invalid"] = 6] = "Invalid";
})(EPurchaseRefundForUpperSupStatus || (EPurchaseRefundForUpperSupStatus = {}));
